import React from "react"
import { ui } from "../../../shared/styles/uiSystem"
import QuickActionSheet from "../../../shared/components/QuickActionSheet"
import StatusBanner from "../../../shared/components/StatusBanner"
import StatusPill from "../../../shared/components/StatusPill"

export default function QuickPaymentDrawer({
  open,
  onClose,
  patientName,
  isReadOnly,
  readOnlyReason,
  formatMoney,
  newPaymentForm,
  setNewPaymentForm,
  pendingReceivables,
  registerNewPayment,
  savingPayment,
  savingAndPrinting
}) {
  const receivables = Array.isArray(pendingReceivables) ? pendingReceivables : []

  return (
    <QuickActionSheet
      open={open}
      onClose={onClose}
      eyebrow="Cobranza rápida"
      title="Registrar pago"
      subtitle={patientName ? `Paciente: ${patientName}` : "Captura inmediata sin salir de la ficha"}
      width={560}
    >
      <div style={{ display: "grid", gap: 16 }}>
        {isReadOnly ? (
          <StatusBanner
            tone="danger"
            title="Cobranza bloqueada"
            text={readOnlyReason}
          />
        ) : null}

        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <StatusPill tone="neutral">
            Cuentas pendientes: {receivables.length}
          </StatusPill>

          <StatusPill tone="info">
            Acción rápida
          </StatusPill>
        </div>

        <div style={drawerCardStyle}>
          <div style={{ display: "grid", gap: 12 }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, minmax(0,1fr))",
                gap: 10
              }}
            >
              <CompactMetricTile
                label="Pendientes"
                value={formatCount(receivables.length)}
              />
              <CompactMetricTile
                label="Modo"
                value="Cobro rápido"
              />
            </div>

            <div
              style={{
                padding: 12,
                borderRadius: 14,
                background:
                  "linear-gradient(180deg, rgba(239,246,255,0.95) 0%, rgba(248,250,252,0.96) 100%)",
                border: "1px solid #dbeafe",
                color: "#1e293b",
                fontSize: 13,
                lineHeight: 1.45,
                fontWeight: 700
              }}
            >
              Registra el cobro aquí y, si quieres, aplícalo en el momento a una cuenta por cobrar pendiente.
            </div>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 12
            }}
          >
            <div>
              <label style={ui.label}>Monto</label>
              <input
                type="number"
                placeholder="0.00"
                value={newPaymentForm.amount}
                onChange={(e) =>
                  setNewPaymentForm((prev) => ({
                    ...prev,
                    amount: e.target.value
                  }))
                }
                style={ui.input}
                disabled={isReadOnly}
              />
            </div>

            <div>
              <label style={ui.label}>Método</label>
              <select
                value={newPaymentForm.method}
                onChange={(e) =>
                  setNewPaymentForm((prev) => ({
                    ...prev,
                    method: e.target.value
                  }))
                }
                style={ui.select}
                disabled={isReadOnly}
              >
                <option value="CASH">Efectivo</option>
                <option value="CARD">Tarjeta</option>
                <option value="TRANSFER">Transferencia</option>
                <option value="MIXED">Mixto</option>
                <option value="OTHER">Otro</option>
              </select>
            </div>
          </div>

          <div>
            <label style={ui.label}>Notas</label>
            <textarea
              rows={3}
              placeholder="Notas del pago"
              value={newPaymentForm.notes}
              onChange={(e) =>
                setNewPaymentForm((prev) => ({
                  ...prev,
                  notes: e.target.value
                }))
              }
              style={ui.textarea}
              disabled={isReadOnly}
            />
          </div>

          <div style={softInnerBoxStyle}>
            <label style={checkboxRowStyle}>
              <input
                type="checkbox"
                checked={newPaymentForm.autoAllocate}
                onChange={(e) =>
                  setNewPaymentForm((prev) => ({
                    ...prev,
                    autoAllocate: e.target.checked,
                    accountReceivableId: e.target.checked
                      ? prev.accountReceivableId
                      : ""
                  }))
                }
                disabled={isReadOnly}
              />
              Aplicar automáticamente a una cuenta por cobrar
            </label>

            {newPaymentForm.autoAllocate ? (
              <div>
                <label style={ui.label}>Cuenta por cobrar destino</label>
                <select
                  value={newPaymentForm.accountReceivableId}
                  onChange={(e) =>
                    setNewPaymentForm((prev) => ({
                      ...prev,
                      accountReceivableId: e.target.value
                    }))
                  }
                  style={ui.select}
                  disabled={isReadOnly}
                >
                  <option value="">Selecciona una cuenta</option>
                  {receivables.map((item) => (
                    <option key={item.id} value={item.id}>
                      {(item.concept || "Cuenta por cobrar")} · Saldo ${formatMoney(item.balance)}
                    </option>
                  ))}
                </select>
              </div>
            ) : null}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 10,
              flexWrap: "wrap"
            }}
          >
            <button
              type="button"
              onClick={() => registerNewPayment({ shouldPrint: false })}
              disabled={savingPayment || savingAndPrinting || isReadOnly}
              style={{
                ...ui.secondaryButton,
                background: "#dbeafe",
                border: "1px solid #bfdbfe",
                color: "#1d4ed8",
                cursor:
                  savingPayment || savingAndPrinting || isReadOnly ? "not-allowed" : "pointer",
                opacity: savingPayment || savingAndPrinting || isReadOnly ? 0.7 : 1
              }}
            >
              {savingPayment ? "Registrando..." : "Registrar pago"}
            </button>

            <button
              type="button"
              onClick={() => registerNewPayment({ shouldPrint: true })}
              disabled={savingPayment || savingAndPrinting || isReadOnly}
              style={{
                ...ui.secondaryButton,
                background: "#dcfce7",
                border: "1px solid #bbf7d0",
                color: "#166534",
                cursor:
                  savingPayment || savingAndPrinting || isReadOnly ? "not-allowed" : "pointer",
                opacity: savingPayment || savingAndPrinting || isReadOnly ? 0.7 : 1
              }}
            >
              {savingAndPrinting ? "Registrando e imprimiendo..." : "Registrar e imprimir"}
            </button>
          </div>
        </div>
      </div>
    </QuickActionSheet>
  )
}

function CompactMetricTile({ label, value }) {
  return (
    <div
      style={{
        ...ui.softCard,
        padding: 12,
        display: "grid",
        gap: 4,
        alignContent: "start"
      }}
    >
      <div
        style={{
          fontSize: 11.5,
          fontWeight: 800,
          color: "#64748b",
          textTransform: "uppercase",
          letterSpacing: 0.3
        }}
      >
        {label}
      </div>

      <div
        style={{
          fontSize: 22,
          lineHeight: 1.05,
          fontWeight: 900,
          color: "#0f172a"
        }}
      >
        {value}
      </div>
    </div>
  )
}

function formatCount(value) {
  const parsed = Number(value)
  const safe = Number.isFinite(parsed) ? parsed : 0

  return new Intl.NumberFormat("es-MX", {
    maximumFractionDigits: 0
  }).format(safe)
}

const drawerCardStyle = {
  borderRadius: 18,
  border: "1px solid #e2e8f0",
  background: "#ffffff",
  boxShadow: "0 8px 18px rgba(15,23,42,0.04)",
  padding: 16,
  display: "grid",
  gap: 14
}

const softInnerBoxStyle = {
  ...ui.softCard,
  padding: 14,
  display: "grid",
  gap: 12
}

const checkboxRowStyle = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  fontSize: 14,
  fontWeight: 700,
  color: "#334155"
}